module.exports = __webpack_public_path__ + "media/images/meeting_points/meeting-point-db43dc9f063925d05e1e67547c3b5ccb.png";